import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '/api/ssl',
  timeout: 12000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

export interface SslStatus {
  domain: string;
  notAfter: string; // ISO
  daysRemaining: number;
  issuer: string;
  autoRenew: boolean;
  nextRenewalApprox: string; // ISO
}

export const sslApi = {
  async getStatus(): Promise<SslStatus> {
    const res = await axiosInstance.get<SslStatus>('/status');
    return res.data;
  },
};
